import React from "react";
import { Alert } from "@fluentui/react-northstar";

export interface FailedToFetchReportErrorProps {
    message: string;
}

const FailedToFetchReportError: React.FC<FailedToFetchReportErrorProps> = ({ message }) => {
    return (
        <div style={{ margin: "10px 0px 0px 0px" }}>
            <Alert danger content={message} />
        </div>
    );
};

export default FailedToFetchReportError;
